import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Link, Switch, Redirect } from 'react-router-dom';
import api from '@/request/api';
import Layout from '@/pages/Layout';
import Login from '@/pages/login/Login';
Component.prototype.api = api;

/**
 * 入口页面  index.js
 */
class App extends React.Component {
  constructor(props) {
    super(props)
    this.token = window.sessionStorage.getItem('token') || null;
  }

  render() {
    return (
      <>
        <BrowserRouter>
          <Switch>
            <Redirect path="/" to={'/index'} exact />
            <Route path="/" {...this.props} component={Layout}></Route>
          </Switch>
        </BrowserRouter>
      </>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('app'))

